<template>
    <div class="loadingBar">
        <img src="./assets/img/loading.svg" alt="">
    </div>
</template>

<script>
    import './assets/css/loading.css';
    export default {
        name: 'Loading'
    }
</script>
